import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENTS_COLUMNS_TOKEN, UNREAD_REPORTS_STORAGE } from '../documents';
import { GeneralDocumentsColumns } from './general-documents-columns';
import { GeneralUnreadReportsStorage } from './general-unread-reports-storage';

@Component({
    selector: 'general-level',
    template: '<router-outlet class="flex-router-outlet"></router-outlet>',
    providers: [
        { provide: DOCUMENTS_COLUMNS_TOKEN, useClass: GeneralDocumentsColumns },
        { provide: UNREAD_REPORTS_STORAGE, useExisting: GeneralUnreadReportsStorage },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralLevelComponent { }
